module.exports = __webpack_public_path__ + "static/img/logo_40.556b35b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_40.png
// module id = vvDU
// module chunks = 1